import { useCatalogueSlice } from 'src/logic/zustand/catalouge';
import {
  useNumberOfSelectedBrands,
  useNumberOfSelectedClassifications,
  useNumberOfSelectedSellers,
  useTotalNumberOfSelections,
} from '../catalogue-content/utils/number-of-selections';
import BrandBanner from './BrandBanner';
import ClassificationBanner from './ClassificationBanner';
import SellerBanner from './SellerBanner';

const allAreZeros = (arr: number[]) => arr.every(num => num === 0);

const CatalogueBanner = () => {
  const { selectedGroup, selectedCategory, selectedClass, selectedTypes, selectedBrands, selectedSellers } =
    useCatalogueSlice(state => state.properties);

  const numberOfSelectedClassifications = useNumberOfSelectedClassifications();
  const numberOfSelectedBrands = useNumberOfSelectedBrands();
  const numberOfSelectedSellers = useNumberOfSelectedSellers();
  const totalNumberOfSelections = useTotalNumberOfSelections();

  if (totalNumberOfSelections === 0) {
    return null;
  }

  const banners = [
    {
      condition: () =>
        numberOfSelectedBrands === 1 && allAreZeros([numberOfSelectedClassifications, numberOfSelectedSellers]),
      content: () => (selectedBrands[0] ? <BrandBanner brand={selectedBrands[0]} /> : null),
    },
    {
      condition: () =>
        numberOfSelectedSellers === 1 && allAreZeros([numberOfSelectedClassifications, numberOfSelectedBrands]),
      content: () => (selectedSellers[0] ? <SellerBanner seller={selectedSellers[0]} /> : null),
    },
    {
      condition: () => selectedTypes.length === 1 && allAreZeros([numberOfSelectedBrands, numberOfSelectedSellers]),
      content: () => (selectedTypes[0] ? <ClassificationBanner category={selectedTypes[0]} /> : null),
    },
    {
      condition: () =>
        Boolean(selectedClass) && allAreZeros([numberOfSelectedBrands, numberOfSelectedSellers, selectedTypes.length]),
      content: () => (selectedClass ? <ClassificationBanner category={selectedClass} /> : null),
    },
    {
      condition: () =>
        Boolean(selectedCategory) &&
        allAreZeros([numberOfSelectedBrands, numberOfSelectedSellers, selectedTypes.length]),
      content: () => (selectedCategory ? <ClassificationBanner category={selectedCategory} /> : null),
    },
    {
      condition: () =>
        Boolean(selectedGroup) && allAreZeros([numberOfSelectedBrands, numberOfSelectedSellers, selectedTypes.length]),
      content: () => (selectedGroup ? <ClassificationBanner category={selectedGroup} /> : null),
    },
  ];

  const bannerToShow = banners.find(banner => banner.condition());
  return bannerToShow ? bannerToShow.content() : null;
};

export default CatalogueBanner;
